import { Config } from "@hey-api/client-fetch";
import { getEnvironment } from "./util/getEnvironment";
import { unreachable } from "./util/unreachable";

// The licensing service is deployed on its own subdomain, separate from the
// main API. This runtime config is wired into the generated licensing client
// via `runtimeConfigPath` in openapi-ts.licensing.config.ts.
const getLicensingBaseUrl = (): string => {
  const env = getEnvironment();
  switch (env) {
    case "PRD":
      return "https://licensing.pleevi.ai";
    case "STG":
      return "https://licensing.stg.pleevi.ai";
    case "SBX":
      return "https://licensing.sbx.pleevi.ai";
    case "LOCAL":
      if (window.location.hostname.endsWith("pleevi.localhost")) {
        return `http://${window.location.host.replace(/^portal\./, "licensing.")}`;
      }
      return "http://localhost:8000";
    default:
      return unreachable(env);
  }
};

export const createClientConfig = (config: Config) => ({
  ...config,
  baseUrl: getLicensingBaseUrl(),
});
